module.exports = __webpack_public_path__ + "img/LogotipoCompleto.85d19bc3.png";